import classnames from 'classnames';
import React from 'react';

import '@eika/icon-style';

import IconTypes from './IconTypes';

export interface IconProps {
    type: IconTypes;
    className?: string;
    ariaLabel?: string;
    wrapperClassName?: string;
    // @default '24'
    iconSize?: '24' | '20' | '32';
}

const Icon = ({ type, className, ariaLabel, iconSize = '24', wrapperClassName }: IconProps): JSX.Element => {
    const optionalAriaLabel = ariaLabel ? { 'aria-label': ariaLabel } : {};
    return (
        <span className={classnames('sgw-icon', wrapperClassName)}>
            <span
                className={classnames('icon', className, `icon--${type}`, `icon--${iconSize}`)}
                {...optionalAriaLabel}
                aria-hidden={!ariaLabel}
            />
        </span>
    );
};

export default Icon;
